export type NltCompareQuoteSource = 'before' | 'after';
export type NltCompareQuoteMessageRole = 'user' | 'assistant';

export interface NltCompareQuote {
  text: string;
  source: NltCompareQuoteSource;
  messageId?: string;
  messageRole?: NltCompareQuoteMessageRole;
}

export function chatMessageRoleLabel(role: NltCompareQuoteMessageRole): string {
  return role === 'user' ? 'Human message' : 'AI message';
}

export function nltCompareQuoteSourceLabel(source: NltCompareQuoteSource): string {
  return source === 'before' ? 'Before' : 'After';
}

export function formatNltCompareQuoteLabel(quote: NltCompareQuote): string {
  const parts = [nltCompareQuoteSourceLabel(quote.source)];
  if (quote.messageRole) {
    parts.push(chatMessageRoleLabel(quote.messageRole));
  }
  return parts.join(' · ');
}

/** Prepends a compare-chat excerpt to the user's NLT instruction (API stays plain text). */
export function buildNltUserMessageWithQuote(userText: string, quote: NltCompareQuote | null): string {
  const body = userText.trim();
  if (!quote?.text.trim()) return body;

  const header = quote.messageRole
    ? `[Quote from ${formatNltCompareQuoteLabel(quote)}]`
    : `[Quote from ${nltCompareQuoteSourceLabel(quote.source)} test chat]`;
  const block = `${header}\n«${quote.text.trim()}»`;
  return body ? `${block}\n\n${body}` : block;
}
